export default class Visitable {
  accept(visitor) {
    throw new Error("Abstract method!");
  }
}
